import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteTeamFile as deleteTeamFileAPI } from '@/api/v4/team-files.api';
import { QueryKey } from '@/config/query-client';

import { teamIdState } from '../../teams/team.state';
import { useAtomValue } from 'jotai';

export const useDeleteTeamFile = () => {
  const queryClient = useQueryClient();
  const teamId = useAtomValue(teamIdState);

  const mutation = useMutation({
    mutationFn: deleteTeamFileAPI,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [QueryKey.TeamFiles] });
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.TeamActionsInfo],
      });
    },
  });

  const deleteTeamFile = (fileId: string) => {
    if (!teamId) return;

    return mutation.mutateAsync({ teamId, fileId });
  };

  return {
    deleteTeamFile,
    isError: mutation.isError,
  };
};
